import { useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import UAParser from 'ua-parser-js';
import Loader from '../components/Loader';
import { Section, SectionLink, SectionName } from '../components/Chrome';
import {
  Drawer,
  DrawerExit,
  DrawerLink,
  DrawerList,
  DrawerTrigger,
} from '../components/Drawer';
import Icon from '../components/Icon';
import { VIEWER_SESSIONS } from '../utilities/queries';
import DeleteSessionModal from '../modals/DeleteSession';

const SettingsSessionsPage = () => {
  const { data } = useQuery(VIEWER_SESSIONS);
  const [isDeleteSessionModalOpen, setIsDeleteSessionModalOpen] =
    useState(false);

  // Used to pass session data to action modals
  const [session, setSession] = useState();

  // Tracks the session the viewer is interacting with
  const listRef = useRef();
  const [trackSession, setTrackSession] = useState();

  const parse = (agent, ipAddress) => {
    const parser = new UAParser(agent);
    const OS = parser.getOS();
    const browser = parser.getBrowser();

    return `${OS.name} · ${browser.name} · ${ipAddress}`;
  };

  return (
    <>
      <Helmet>
        <title>Sessions</title>
      </Helmet>
      <Section>
        {!data ? (
          <Loader />
        ) : (
          <>
            <SectionName isSecondLevel>Sessions</SectionName>
            {data.viewer.sessions.map((session) => (
              <Drawer key={session.id} onClose={() => setTrackSession(null)}>
                <DrawerTrigger onClick={() => setTrackSession(session.id)}>
                  <SectionLink
                    as="button"
                    isActive={trackSession === session.id}
                  >
                    <div>
                      {parse(session.userAgent, session.ipAddress)}{' '}
                      {data.viewer.currentSession === session.id && '(current)'}
                    </div>
                    <Icon name="more" />
                  </SectionLink>
                </DrawerTrigger>
                <DrawerList ref={listRef}>
                  <DrawerExit />
                  <DrawerLink
                    as="button"
                    onClick={() => {
                      setSession(session);
                      setIsDeleteSessionModalOpen(true);
                    }}
                    dontRunOnClose
                  >
                    Remove session
                  </DrawerLink>
                </DrawerList>
              </Drawer>
            ))}
          </>
        )}
      </Section>
      {isDeleteSessionModalOpen && (
        <DeleteSessionModal
          session={session}
          onClose={() => {
            setTrackSession(null);
            setIsDeleteSessionModalOpen(false);
          }}
        />
      )}
      <Outlet />
    </>
  );
};

export default SettingsSessionsPage;
